
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
  }
}

export default function ThanksPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Google Ads コンバージョントラッキング
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17951538841/JifsCMPG-fcbEJn9-u9C'
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* ナビゲーション */}
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/0e64fe7d7ddf660e67742842ccecd709.png" alt="ロゴ" className="h-8 md:h-10 w-auto" />
          </Link>
        </div>
      </nav>

      {/* メインコンテンツ */}
      <main className="py-16 md:py-24 px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          {/* 成功アイコン */}
          <div className="w-20 h-20 md:w-24 md:h-24 bg-[#2C5F2D] rounded-full flex items-center justify-center mx-auto mb-6 md:mb-8">
            <i className="ri-check-line text-4xl md:text-5xl text-white"></i>
          </div>

          <h1 className="text-2xl md:text-4xl lg:text-5xl font-black mb-4 md:mb-6">
            お申し込み<br className="md:hidden" />ありがとうございます
          </h1>

          <p className="text-base md:text-xl text-[#666666] mb-8 md:mb-12 leading-relaxed">
            初期設計のお申し込みを受け付けました。<br />
            <strong className="text-[#1A1A1A]">3営業日以内</strong>に担当者よりご連絡いたします。
          </p>

          {/* 確認事項 */}
          <div className="bg-[#F0F7F0] rounded-2xl md:rounded-3xl p-6 md:p-10 mb-8 md:mb-12 text-left">
            <h2 className="text-lg md:text-xl font-bold text-[#2C5F2D] mb-4 md:mb-6 text-center">
              <i className="ri-mail-check-line mr-2"></i>
              ご確認ください
            </h2>
            
            <ul className="space-y-3 md:space-y-4">
              <li className="flex items-start gap-3 md:gap-4">
                <div className="w-6 h-6 bg-[#2C5F2D] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-white text-xs font-bold">1</span>
                </div>
                <p className="text-sm md:text-base text-[#666666]">
                  ご入力いただいたメールアドレスに確認メールをお送りしました。届いていない場合は迷惑メールフォルダをご確認ください。
                </p>
              </li>
              <li className="flex items-start gap-3 md:gap-4">
                <div className="w-6 h-6 bg-[#2C5F2D] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-white text-xs font-bold">2</span>
                </div>
                <p className="text-sm md:text-base text-[#666666]">
                  担当者より、設計に必要な追加情報のヒアリングについてご連絡いたします。
                </p>
              </li>
              <li className="flex items-start gap-3 md:gap-4">
                <div className="w-6 h-6 bg-[#2C5F2D] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-white text-xs font-bold">3</span>
                </div>
                <p className="text-sm md:text-base text-[#666666]">
                  ヒアリング後、約2週間で設計書（PDF）を納品いたします。
                </p>
              </li>
            </ul>
          </div>

          {/* 納品物の説明 */}
          <div className="bg-[#2C5F2D] text-white rounded-2xl md:rounded-3xl p-6 md:p-10 mb-8 md:mb-12">
            <div className="inline-block bg-[#7CB342] text-[#2C5F2D] px-4 md:px-6 py-1 md:py-2 rounded-full font-bold text-xs md:text-sm mb-4 md:mb-6">
              納品予定
            </div>
            <p className="text-xl md:text-3xl font-black mb-3 md:mb-4">
              25ページ前後の<br className="md:hidden" />PDF設計書
            </p>
            <p className="text-sm md:text-base opacity-90">
              競合分析・価格ポジション診断・成約率改善設計・<br className="hidden md:block" />
              粗利シミュレーション・90日改善ロードマップを含む
            </p>
          </div>

          {/* CTAボタン */}
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 md:gap-3 bg-white text-[#2C5F2D] border-2 border-[#2C5F2D] px-6 md:px-10 py-3 md:py-4 rounded-2xl font-bold text-sm md:text-lg hover:bg-[#F0F7F0] transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg md:text-xl"></i>
            トップページに戻る
          </Link>
        </div>
      </main>

      {/* フッター */}
      <footer className="bg-[#2A2A2A] text-white py-8 md:py-12 px-4 md:px-6">
        <div className="max-w-7xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-4 md:mb-6">
            <img src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/0e64fe7d7ddf660e67742842ccecd709.png" alt="ロゴ" className="h-6 md:h-8 w-auto" />
          </div>
          <p className="text-xs md:text-sm text-[#999999] mb-4">
            外構工事専門の粗利改善コンサルティング
          </p>
          <div className="flex items-center justify-center gap-3 md:gap-4">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-[10px] md:text-xs text-[#999999] hover:text-white transition-colors">
              Powered by Readdy
            </a>
          </div>
          <p className="text-xs text-[#666666] mt-4">
            © 2025 外構工事専門コンサルティング. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
